import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import { useInriStore } from '../stores/inriStore'


export default /*#__PURE__*/_defineComponent({
  props: {
  left: {
    type: Boolean,
    default: false,
  },
  color: {
    type: String,
    default: 'primary',
  },
  textColor: {
    type: String,
    default: 'on-primary',
  },
},
  setup(__props) {

const props = __props



const drawerButton = ref()
const inriStore = useInriStore()
const isOpen = computed(() => props.left ? inriStore.state.leftDrawerIsOpen : inriStore.state.rightDrawerIsOpen)

function toggle () {
  if (props.left) {
    inriStore.toggleLeftDrawer()
  } else {
    inriStore.toggleRightDrawer()
  }

  // Remove focus from button on click
  drawerButton.value.$el.blur()
}

return (_ctx: any,_cache: any) => {
  const _component_c_slide_effect = _resolveComponent("c-slide-effect")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    ref_key: "drawerButton",
    ref: drawerButton,
    "data-id": "drawer-btn",
    class: _normalizeClass(["drawer-button group", {
      'is-left': __props.left,
      'w-60px sm:w-340px': _unref(isOpen),
      'w-60px': !_unref(isOpen)
    }]),
    color: __props.color,
    "text-color": __props.textColor,
    unelevated: "",
    "aria-label": _ctx.$t('inri.toggle_drawer'),
    onClick: toggle
  }, {
    default: _withCtx(() => [
      _createVNode(_component_c_slide_effect, {
        "parent-color": __props.color,
        "slide-right": "",
        class: "-z-1"
      }, null, 8, ["parent-color"]),
      _createVNode(_component_q_icon, {
        name: !__props.left ? 'mdi-chevron-left' : 'mdi-chevron-right',
        class: _normalizeClass(_unref(isOpen) ? 'rotate-180' : 'rotate-360')
      }, null, 8, ["name", "class"])
    ]),
    _: 1
  }, 8, ["class", "color", "text-color", "aria-label"]))
}
}

})